import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { get as getStateDatas } from 'store/academic/student/state-data'
import { useEffect } from 'react'
import StudentFormUsNj from '../../../Member/StateData/Forms/us/nj/student-form'
import EmptyForm from '../../../Member/StateData/Forms/empty'
import { getLanguages, getStateDataType } from 'store/lookup'
import { Box, Drawer, Grid } from '@mui/material'
import PersonalInfoCard from '../../../Member/StateData/PersonalInfoCard'
import SPEDInfoCard from '../../../Member/StateData/SPEDInfoCard'
import ELLInfoCard from '../../../Member/StateData/ELLInfoCard'
import { useMember } from 'components/Providers'

export default function StateData() {
  const { part } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const member = useMember()

  const languages = useSelector(state => state.lookup.languages)
  const stateData = useSelector(state => state.academic.student.detail.stateData)
  const { country, state } = useSelector(state => state.session.campus?.address)
  const employmentStateDataType = useSelector(state => state.lookup.stateDataType)?.filter(
    item => item.type === member?.employment?.type,
  )
  const basePath = `/member/${member?.employment?.type}/${member?.id}/state-data`
  const sharedStateDataType = useSelector(state => state.lookup.stateDataType)?.filter(item => item.type === 'shared')

  useEffect(() => {
    stateData || dispatch(getStateDatas({ type: member?.employment?.type, memberId: member?.id }))
  }, [member?.id])

  useEffect(() => {
    employmentStateDataType ||
      dispatch(getStateDataType({ state: state.toLowerCase(), type: member?.employment?.type }))
    languages || dispatch(getLanguages())
  }, [])

  const getFormComponent = () => {
    const key = [country.toLowerCase(), state.toLowerCase(), member?.employment?.type].join('.')
    switch (key) {
      case 'us.nj.student':
        return StudentFormUsNj
      default:
        return EmptyForm
    }
  }

  const StateDataForm = getFormComponent()

  if (!(country && state && member?.id && employmentStateDataType && languages)) return null

  return (
    <Box sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <>
          <Grid item xs={12} md={12}>
            <PersonalInfoCard
              member={{ ...member, stateData }}
              employmentStateDataType={employmentStateDataType}
              languages={languages}
              onlyReadable={true}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <ELLInfoCard
              member={{ ...member, stateData }}
              employmentStateDataType={employmentStateDataType}
              sharedStateDataType={sharedStateDataType}
              onlyReadable={true}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <SPEDInfoCard member={{ ...member, stateData }} onlyReadable={true} />
          </Grid>
        </>
      </Grid>
      <Drawer
        PaperProps={{
          sx: {
            width: 800,
          },
        }}
        open={Boolean(part)}
        anchor="right"
        onClose={() => navigate(`${basePath}`)}
      >
        <StateDataForm stateDataType={employmentStateDataType} sharedStateDataType={sharedStateDataType} />
      </Drawer>
    </Box>
  )
}
